import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { showCookieBanner } from "./CookieConsent";
import logo from "@/assets/logo.webp";
import { GOOGLE_REVIEWS_URL } from "./GoogleReviews";
import tripadvisorHof from "@/assets/tripadvisor-hof.png";
import birderFriendly from "@/assets/birder-friendly.png";
import travelersChoice from "@/assets/travelers-choice-2025.png";

const exploreLinks = [
  { label: "Rooms & Suites", to: "/rooms" },
  { label: "Culinary Safari", to: "/culinary" },
  { label: "African Spa", to: "/spa" },
  { label: "Safari Experiences", to: "/experiences" },
  { label: "Special Offers", to: "/offers" },
];

const infoLinks = [
  { label: "About Us", to: "/" },
  { label: "Location & Access", to: "/location" },
  { label: "Gallery", to: "/gallery" },
  { label: "Journal", to: "/journal" },
  { label: "Meetings & Events", to: "/events" },
  
];

const socialLinks = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/ZwahiliGameLodge",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/zwahiligamelodge",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@zwahiligamelodge",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/zwahili-game-lodge",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    label: "TripAdvisor",
    href: "https://www.tripadvisor.com/Hotel_Review-g12247498-d1220498-Reviews-Zwahili_Game_Lodge_Spa-Mookgophong_Naboomspruit_Limpopo_Province.html",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 004.04 10.43 5.976 5.976 0 004.075-1.6L12 19.705l1.922-2.09a5.972 5.972 0 004.075 1.6 5.997 5.997 0 004.04-10.43l1.963-2.134h-4.361A14.95 14.95 0 0012.006 4.295zm0 2.09c1.87 0 3.735.478 5.39 1.393H6.615a12.85 12.85 0 015.39-1.394zM6.003 9.87a3.908 3.908 0 110 7.816 3.908 3.908 0 010-7.816zm11.994 0a3.908 3.908 0 110 7.816 3.908 3.908 0 010-7.816zM6.003 11.962a1.816 1.816 0 100 3.632 1.816 1.816 0 000-3.632zm11.994 0a1.816 1.816 0 100 3.632 1.816 1.816 0 000-3.632z" />
      </svg>
    ),
  },
  {
    label: "Share",
    href: "#",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" />
      </svg>
    ),
  },
];

const Footer = () => {
  return (
    <footer className="bg-[hsl(0,0%,5%)] border-t border-[hsl(38,20%,22%)] text-[hsl(40,30%,90%)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
        {/* Main grid: Brand | Explore | Information | Contact */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 sm:gap-10 lg:gap-12 mb-12 sm:mb-14 divide-y divide-[hsl(38,20%,22%)]/60 sm:divide-y-0 [&>*:not(:first-child)]:pt-10 sm:[&>*:not(:first-child)]:pt-0">
          {/* Brand */}
          <div className="lg:col-span-4">
            <Link to="/">
              <img
                src={logo}
                alt="Zwahili Private Game Lodge & Spa"
                className="h-16 w-auto mb-6"
              />
            </Link>
            <p className="text-[15px] sm:text-sm text-[hsl(40,10%,55%)] leading-relaxed mb-6 sm:mb-8 max-w-md">
              Experience unparalleled luxury in the heart of the African
              wilderness. Where nature meets sophistication.
            </p>
            <div className="flex flex-wrap items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-9 h-9 rounded-full border border-[hsl(38,20%,22%)] flex items-center justify-center text-[hsl(40,10%,55%)] hover:text-gold hover:border-gold transition-colors"
                >
                  {social.icon}
                </a>
              ))}
            </div>
            <a
              href={GOOGLE_REVIEWS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-5 text-[15px] sm:text-sm text-[hsl(40,10%,55%)] hover:text-gold transition-colors"
            >
              Read our Google Reviews
            </a>
          </div>

          {/* Explore */}
          <div className="lg:col-span-2">
            <h3 className="font-heading text-xs sm:text-sm tracking-[0.2em] uppercase text-[hsl(40,30%,90%)] mb-4 sm:mb-5">
              Explore
            </h3>
            <ul className="space-y-2.5 sm:space-y-3">
              {exploreLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-[15px] sm:text-sm text-[hsl(40,10%,55%)] hover:text-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Information */}
          <div className="lg:col-span-2">
            <h3 className="font-heading text-xs sm:text-sm tracking-[0.2em] uppercase text-[hsl(40,30%,90%)] mb-4 sm:mb-5">
              Information
            </h3>
            <ul className="space-y-2.5 sm:space-y-3">
              {infoLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-[15px] sm:text-sm text-[hsl(40,10%,55%)] hover:text-gold transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <h3 className="font-heading text-xs sm:text-sm tracking-[0.2em] uppercase text-[hsl(40,30%,90%)] mb-4 sm:mb-5">
              Contact
            </h3>
            <ul className="space-y-3.5 sm:space-y-4 mb-6 sm:mb-8">
              <li className="flex items-start gap-3 text-[15px] sm:text-sm text-[hsl(40,10%,55%)]">
                <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
                Zwahili Private Game Lodge & Spa
              </li>
              <li>
                <a
                  href="tel:+27123620681"
                  className="flex items-center gap-3 text-[15px] sm:text-sm text-[hsl(40,10%,55%)] hover:text-gold transition-colors"
                >
                  <Phone size={16} className="shrink-0 text-gold" />
                  +27 12 362 0681
                </a>
              </li>
              <li>
                <a
                  href="mailto:reservations@zgl.co.za"
                  className="flex items-center gap-3 text-[15px] sm:text-sm text-[hsl(40,10%,55%)] hover:text-gold transition-colors"
                >
                  <Mail size={16} className="shrink-0 text-gold" />
                  reservations@zgl.co.za
                </a>
              </li>
            </ul>

            {/* Accreditation logos */}
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="https://www.tripadvisor.com/Hotel_Review-g12247498-d1220498-Reviews-Zwahili_Game_Lodge_Spa-Mookgophong_Naboomspruit_Limpopo_Province.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={tripadvisorHof}
                  alt="TripAdvisor Hall of Fame"
                  className="h-20 w-auto"
                />
              </a>
              <img
                src={birderFriendly}
                alt="BirdLife Birder Friendly"
                className="h-20 w-auto"
              />
              <a
                href="https://www.tripadvisor.com/Hotel_Review-g12247498-d1220498-Reviews-Zwahili_Game_Lodge_Spa-Mookgophong_Naboomspruit_Limpopo_Province.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={travelersChoice}
                  alt="TripAdvisor Travelers' Choice 2025"
                  className="h-20 w-auto"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright bar */}
        <div className="border-t border-[hsl(38,20%,22%)] pt-6 flex flex-col items-center gap-4 text-center">
          <p className="text-xs text-[hsl(40,10%,40%)] leading-relaxed">
            © {new Date().getFullYear()} Zwahili Private Game Lodge & Spa. All
            rights reserved. All content, imagery and trademarks on this site
            are protected by copyright — unauthorised reproduction is prohibited.
          </p>
          <div className="flex flex-col sm:flex-row sm:flex-wrap justify-center items-center gap-y-3 sm:gap-y-2 sm:gap-x-5 text-xs text-[hsl(40,10%,40%)]">
            <Link to="/terms" className="hover:text-gold transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-gold transition-colors">
              Privacy Policy
            </Link>
            <Link to="/disclaimer" className="hover:text-gold transition-colors">
              Disclaimer
            </Link>
            <button
              onClick={showCookieBanner}
              className="hover:text-gold transition-colors"
            >
              Manage Cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
